import React, { useState } from "react";
import QTIcon from "./assets/qtIcon.png";
import { NavLink } from "react-router-dom";
import styles from "./Navigation.module.scss";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
// import { PopupButton } from "@typeform/embed-react";
const { nav, icon, links, cta, active, toggler, activeMobileView } = styles;
function Navigation() {
  const navigate = useNavigate();
  const [mobileClasses, setMobileClasses] = useState([links]);
  const handleToggler = () =>
    setMobileClasses((prevClass) =>
      prevClass.includes(activeMobileView) ? [links] : [links, activeMobileView]
    );
  return (
    <nav className={`${nav} global-lr-pad`}>
      <div className={icon} onClick={() => navigate("/")}>
        <img src={QTIcon} alt="We quick pay" />
        <h1>We Quick Pay</h1>
      </div>

      <div className={mobileClasses.join(" ")}>
        <NavLink to="/" className={({ isActive }) => (isActive ? active : "")}>
          Home
        </NavLink>
        <NavLink
          to="/features"
          className={({ isActive }) => (isActive ? active : "")}
        >
          Features
        </NavLink>
        <NavLink
          to="/faqs"
          className={({ isActive }) => (isActive ? active : "")}
        >
          Faqs
        </NavLink>
        <NavLink
          to="/contact"
          className={({ isActive }) => (isActive ? active : "")}
        >
          Contact Us
        </NavLink>
        <NavLink
          to="/about"
          className={({ isActive }) => (isActive ? active : "")}
        >
          About Us
        </NavLink>
      </div>
      <div className={cta}>
        <button>Register/Login</button>

        {/* <PopupButton id="SFfrzHj6">Register/Login</PopupButton> */}
      </div>
      <button className={toggler} onClick={handleToggler}>
        {mobileClasses.includes(activeMobileView) ? (
          <Icon icon="ic:round-close" />
        ) : (
          <Icon icon="ic:sharp-menu-open" />
        )}
      </button>
    </nav>
  );
}

export default Navigation;
